import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";
import { hasWindow } from "@omni/utils/dom.utils";
import * as SessionStorage from "@omni/utils/sessionStorage.utils";

import FeatureTogglesService from "@/services/featureToggle/featureToggles.service";

import EventDataLayer, { SubscriberCallback } from "../../queue/EventDataLayer";

const DebugSubscriber = (
    eventDataLayer: EventDataLayer,
    withHistory = false
) => {
    eventDataLayer.subscribe("debugger", subscribe, withHistory);
};

const subscribe: SubscriberCallback = (event, data): void => {
    if (
        FeatureTogglesService.isEnabled(
            FeatureToggleKey.DEBUG_EVENT_DATA_LAYER_LOGGING
        )
    ) {
        console.groupCollapsed(`hubo:EventDataLayer:debugger - event`, event);
        console.log(data);
        console.groupEnd();

        if (hasWindow()) {
            let eventLog = SessionStorage.getItem("eventLog");
            eventLog += `,${JSON.stringify(data)}`;
            SessionStorage.setItem("eventLog", `${eventLog}`);
            window.postMessage("analytics-track-change", "*");
        }
    }
};

export { DebugSubscriber };
